<template>
	<div class="input-group">
		<input type="number" min="1" max="31" v-model="dia" placeholder="Dia" class="form-control">
		<select class="form-control" v-model="mes">
			<option value="">Mês...</option>
			<option value="01">Jan</option>
			<option value="02">Fev</option>
			<option value="03">Mar</option>
			<option value="04">Abr</option>
			<option value="05">Mai</option>
			<option value="06">Jun</option>
			<option value="07">Jul</option>
			<option value="08">Ago</option>
			<option value="09">Set</option>
			<option value="10">Out</option>
			<option value="11">Nov</option>
			<option value="12">Dez</option>
		</select>
		<input type="number" min="1900" max="2050" v-model="ano" placeholder="Ano" class="form-control">
	</div>
</template>

<script type="text/javascript">
	export default {
		data() {
			return { 
				dia: "",
				mes: "",
				ano: "", 
			};
		},

		props: ['value'],

		watch: { 
			value: function () {
				if ( this.value ) { 
					this.ano = this.value.substr(0,4);
					this.mes = this.value.substr(5,2);
					this.dia = this.value.substr(8,2);
				} else { 
					this.ano = "";
					this.mes = "";
					this.dia = "";
				}
			},

			ano: function () { 
				let data = this.compor();

				if ( data )
					this.$emit('input', data);
			},

			mes: function () { 
				let data = this.compor();

				if ( data )
					this.$emit('input', data);
			},

			dia: function () { 
				let data = this.compor();

				if ( data )
					this.$emit('input', data);
			}
		},

		methods: { 
			compor() { 
				let data = ""; 

				if ( this.ano && this.ano >= 1900 && this.ano <= 2021 )
					data = this.ano + '-';
				else 
					return;

				if ( this.mes )
					data = data + this.mes + '-';
				else 
					return;

				if ( this.dia >= 1 && this.dia <= 31 )
					data = data + ( this.dia < 10 ? '0' : '' ) + parseInt(this.dia);
				else
					return;

				return data;
			}
		}
	}
</script>